module.exports = __webpack_public_path__ + "static/img/confuse.89db0d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/confuse.png
// module id = IYXL
// module chunks = 1